<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Row>
                <Col span="24">
                    <Timeline>
                        <TimelineItem v-for="(item, index) in dataList" :key="index">
                            <p class="time">{{item.create_time}}</p>
                            <p class="content">{{item.remark}}</p>
                        </TimelineItem>
                    </Timeline>

                </Col>
            </Row>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">关闭</Button>
            </div>
        </div>
    </Drawer>
</template>

<script>

import {getProjectLogTreeList} from "@/apis/project";

export default {
    name: 'ProjectLog',
    components: {
    },
    data () {
        return {
            title: '项目日志',
            dataList: [],
            isBox: false
        }
    },
    methods: {
        /**
         功能：
         time: 2025/12/16 10:44
         **/
        getTreeList(project_id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getProjectLogTreeList(project_id).then(e => {
                that.dataList = e.data;
            })
        },
        /**
         功能：
         time: 2025/12/16 10:44
         **/
        show(project_id, name){
            this.isBox = true;
            this.title = name + " - 项目日志"
            if(project_id) this.getTreeList(project_id);
        },
        /**
         功能：
         time: 2025/12/16 10:44
         **/
        FormReset(){
            this.isBox = false;
            this.title = '项目日志';
            this.dataList =  [];
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

</style>
